function nextTimeRange(start: number, end: number): { start: number, end: number } {
  const diff = end - start;
  const newStart = end;
  const newEnd = end + diff;
  
  return { start: newStart, end: newEnd }
}

export default nextTimeRange;
